import validator from 'validator'

import { dateReformatting } from './dateReformatting'

export const isValidDate = (dateString: string): boolean => {
  const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/
  if (!dateRegex.test(dateString)) {
    dateString = dateReformatting(dateString)
  }

  const [day, month, year] = dateString.split('.').map(Number)
  const formattedDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`

  if (!validator.isDate(formattedDate, { format: 'YYYY-MM-DD', strictMode: true })) {
    return false
  }

  const inputDate = new Date(year, month - 1, day)
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return inputDate >= today
}
